import React from 'react';
import omit from 'lodash/omit';
import keyMirror from 'keymirror';

export const BoundedElementsReducerActions = keyMirror({
    ADD_ITEM: null,
    REMOVE_ITEM: null,
});

export const MapContext = React.createContext(null);

export const boundedElementsReducer = (state, action) => {
    switch (action.type) {
        case BoundedElementsReducerActions.ADD_ITEM:
            return {...state, [action.uid]: action.coords};
        case BoundedElementsReducerActions.REMOVE_ITEM:
            return {...omit(state, action.uid)};
        default:
            return state;
    }
};

export const useMap = () => {
    return React.useContext(MapContext);
};



// WEBPACK FOOTER //
// ./src/components/openMap/MapContext.js